import { StateCreator } from "zustand";

interface User {
  id: string | null;
  email: string | null;
  role: string | null;
  nickname: string | null;
}

export interface authenticationTypes {
  authentication: boolean;
  user: User | null;
  setAuth: (user: User) => void;
  removeAuth: () => void;
}

export const authStateSlice: StateCreator<authenticationTypes> = (set) => ({
  authentication: false,
  user: null,

  setAuth: (user: User) =>
    set({
      authentication: true,
      user: {
        id: user.id,
        email: user.email,
        role: user.role,
        nickname: user.nickname,
      },
    }),

  removeAuth: () =>
    set({
      authentication: false,
      user: null,
    }),
});
